import React from 'react';

import { GraphIdentifier } from '../usePerGraphIdentifierLocalStorage';

import { ResponseAndMetrics } from './performOperation/performOperation';

export interface ExplorerResponse {
  type: 'response';
  runId: string;
  data: ResponseAndMetrics;
  operationName?: string;
  operationString: string;
}
export interface ExplorerLoading {
  type: 'loading';
  previousResponse: ExplorerResponse | ExplorerError | undefined;
}
export interface ExplorerError {
  type: 'error';
  name: string;
  message: string;
  stack?: string;
}
export type ExplorerResult =
  | ExplorerResponse
  | ExplorerLoading
  | ExplorerError
  | undefined;

type ExplorerResultsByTab = {
  [tabId: string]: ExplorerResult;
};

const explorerResultsByGraphIdentifierCache: {
  [refKey: string]: ExplorerResultsByTab;
} = {};
export const useExplorerResponses = (
  localStorageGraphIdentifier: GraphIdentifier,
) => {
  const key = `${localStorageGraphIdentifier.domain}@${localStorageGraphIdentifier.id}`;
  const [responses, setResponses] = React.useState<ExplorerResultsByTab>(
    explorerResultsByGraphIdentifierCache[key] ?? {},
  );
  React.useEffect(() => {
    explorerResultsByGraphIdentifierCache[key] = responses;
  }, [responses, key]);
  return [responses, setResponses] as const;
};
